import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { isUploadError, isUploadIdle, uploadStatusError, uploadStatusIdle, isUploadSuccess } from '../types.js';
import { createNoFileError, getUploadErrorLabel } from '../utils.js';

function useUploadHandler(props) {
    const [lastError, setLastError] = React__default.useState(()=>{
        /**
     * It should check the uploadStatus for all config.handlers and if one of them is in
     * error state the {lastError}, should reflect it.It should also check
     * if config.checkRequired is being set, and if so checks for required property in each handler.
     */ const { isRequired: isRequired1 , hasError: hasError1  } = props.configs.reduce(({ isRequired , hasError  }, { required , uploadStatus  })=>({
                isRequired: isRequired || required,
                hasError: hasError || !!(uploadStatus && isUploadError(uploadStatus))
            })
        , {
            isRequired: false,
            hasError: false
        });
        if (hasError1 || props.checkRequired && isRequired1) {
            return createNoFileError();
        }
        return undefined;
    });
    const [, setIsSubmitted] = React__default.useState(!!props.checkRequired);
    const handlers = React__default.useRef(props.configs.reduce((h, { scope  })=>swcHelpers.objectSpread({}, h, {
            [scope]: getStatusChangeHandler(scope)
        })
    , {}));
    const [state, setState] = React__default.useState(props.configs.reduce((s, { scope , uploadStatus , required  })=>{
        if (uploadStatus && isUploadSuccess(uploadStatus)) {
            return swcHelpers.objectSpread({}, s, {
                [scope]: uploadStatus
            });
        }
        if (required && props.checkRequired) {
            return swcHelpers.objectSpread({}, s, {
                [scope]: uploadStatusError(createNoFileError(), props.sharedErrorElementId)
            });
        }
        return swcHelpers.objectSpread({}, s, {
            [scope]: uploadStatusIdle()
        });
    }, {}));
    function getStatusChangeHandler(scope1) {
        var ref;
        const isRequired = (ref = props.configs.find(({ scope  })=>scope === scope
        )) === null || ref === void 0 ? void 0 : ref.required;
        return (statusUpdate)=>{
            setIsSubmitted((prevIsSubmitted)=>{
                setState((prevState)=>Object.entries(prevState).reduce((m, [key, status])=>{
                        if (key === scope1) {
                            const possiblyError = isUploadError(statusUpdate) ? statusUpdate.error : null;
                            /**
               * If the status update is indicating that a required file will be removed, we'll override
               * the error to be a "no-file" error.
               */ const error = isUploadIdle(statusUpdate) && isRequired && prevIsSubmitted ? new Error('no-file') : possiblyError;
                            setLastError(error || undefined);
                            return swcHelpers.objectSpread({}, m, {
                                [key]: error ? uploadStatusError(error, props.sharedErrorElementId) : statusUpdate
                            });
                        }
                        /**
             * To only show the last triggered status update, we're setting all other scopes to IDLE in
             * case they are in ERROR state. We want to keep all scopes that are SUCCESS as is.
             */ return swcHelpers.objectSpread({}, m, {
                            [key]: isUploadError(status) ? uploadStatusIdle() : status
                        });
                    }, {})
                );
                return prevIsSubmitted;
            });
        };
    }
    function checkMissingFiles() {
        let hasMissingFiles = false;
        const newState = props.configs.reduce((m, { scope , required  })=>{
            if (required && !isUploadSuccess(state[scope])) {
                const error = createNoFileError();
                setLastError(error);
                hasMissingFiles = true;
                return swcHelpers.objectSpread({}, m, {
                    [scope]: uploadStatusError(error)
                });
            }
            return m;
        }, {});
        setState((prevState)=>swcHelpers.objectSpread({}, prevState, newState)
        );
        setIsSubmitted(true);
        return hasMissingFiles;
    }
    return {
        lastError: lastError ? getUploadErrorLabel(lastError) : null,
        checkMissingFiles,
        state,
        handlers: handlers.current
    };
}

export { useUploadHandler };
//# sourceMappingURL=use-upload-handler.js.map
